"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bold = exports.Medium = exports.Regular = exports.Default = exports.Hairline = exports.None = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var None = 0;
exports.None = None;
var Hairline = 1;
exports.Hairline = Hairline;
var Default = 1;
exports.Default = Default;
var Regular = 1;
exports.Regular = Regular;
var Medium = 2;
exports.Medium = Medium;
var Bold = 3;
exports.Bold = Bold;